(function() {
	('use strict');

	angular
		.module('app.detailCustomReport', [])
		.controller('detailCustomReportCtrl', ['$scope', '$modal', '$modalInstance', 'detailCustomReportService', 'createCustomReportService',
			function ($scope, $modal, $modalInstance, detailCustomReportService, createCustomReportService) {

				$scope.selectedSection = [];

				$scope.getSections = function() {
            		createCustomReportService.getSections(true)
            			.then(function(response) {
            				$scope.sections = response.data;

            				angular.forEach($scope.sections, function(section) {
                                section.checked = false;
                            })

                            angular.forEach($scope.customReportDetailInfo.report_section, function(item) {
                               angular.forEach($scope.sections, function(section) {
                                    if(section.id == item.section_id) {
                                        section.checked = true;
                                        $scope.selectedSection.push({
                                            section_id: item.section_id,
                                            section_preview_image: section.section_preview_image,
                                            position: item.position});
                                    }
                            })
                        })
                    })
            	}

            	$scope.selectSection = function(section) {
            		$scope.isExist = false;
            		if($scope.selectedSection.length == 0) {
            			$scope.selectedSection.push({
                            section_id: section.id, 
                            section_preview_image: section.section_preview_image, 
                            position: 1
                        });
                        section.checked = true;
            		} else {
            			for(var i = $scope.selectedSection.length - 1; i >= 0; i--) {
            				if($scope.selectedSection[i].section_id == section.id) {
            					$scope.isExist = true;
            					$scope.selectedSection.splice(i, 1);
                                section.checked = false;

                                for(var j = i; j < $scope.selectedSection.length; j++) {
                                    $scope.selectedSection[j].position = $scope.selectedSection[j].position - 1;
                                }
            				}
                            
            			}

            			if($scope.isExist == false) {
            				$scope.selectedSection.push({
                                section_id: section.id, 
                                section_preview_image: section.section_preview_image, 
                                position: $scope.selectedSection.length + 1});
                            section.checked = true;
            			}
            		}
            	}

            	$scope.sectionRemove = function(section) {
                    for(var i = $scope.selectedSection.length - 1; i >= 0; i--) {
                        if($scope.selectedSection[i].section_id == section.section_id) {
                            $scope.selectedSection.splice(i, 1);

                            for(var j = i; j < $scope.selectedSection.length; j++) {
                                $scope.selectedSection[j].position = $scope.selectedSection[j].position - 1;
                            }
                        }
                    }
                    for(var i=0; i<$scope.sections.length; i++) {
                        if($scope.sections[i].id == section.section_id) {
                            $scope.sections[i].checked = false;
                        }
                    }
                }

				$scope.getDetailCustomReport = function() {
					detailCustomReportService.getDetailCustomReport($scope.report_id, true)
						.then(function(response) {
                            
							$scope.customReportDetailInfo = response.data;
							$scope.customReportName = $scope.customReportDetailInfo.report_name;
                    		$scope.getSections();

						}, function(response) {
							var errorModalInstance = $modal.open({
			                    scope: $scope,
			                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
			                    windowClass: 'modal-dialog-mention-error'
			                });
			                $scope.errorModalInstance = errorModalInstance;
			                $scope.errorMessage = response.message;
						})
				}

                $scope.editCustomReport = function(report_id, is_default_report) {
                    if(is_default_report == 1) {
                        var saveAsCustomReportModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/measure/customReport/detailCustomReport/saveAsCustomReport/saveAsCustomReport.html?app_v=deployDate',
                            controller: 'saveAsCustomReportCtrl',
                        });

                        $scope.customReportName;
                        $scope.reportId = report_id;
                        $scope.selectedSection;
                        $scope.saveAsCustomReportModalInstance = saveAsCustomReportModalInstance;
                        $scope.detailCustomReportModalInstance;
                    } else {
                        var editCustomReportModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/measure/customReport/detailCustomReport/editCustomReport/editCustomReport.html?app_v=deployDate',
                            controller: 'editCustomReportCtrl',
                        });

                        $scope.customReportName;
                        $scope.reportId = report_id;
                        $scope.selectedAdvertiser;
                        $scope.selectedSection;
                        $scope.editCustomReportModalInstance = editCustomReportModalInstance;
                        $scope.detailCustomReportModalInstance;
                    }  
                }

                $scope.saveAsCustomReport = function(report_id) {
                    var saveAsCustomReportModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/measure/customReport/detailCustomReport/saveAsCustomReport/saveAsCustomReport.html?app_v=deployDate',
                        controller: 'saveAsCustomReportCtrl',
                    });

                    $scope.customReportName;
                    $scope.reportId = report_id;
                    $scope.selectedAdvertiser;
                    $scope.selectedSection;
                    $scope.saveAsCustomReportModalInstance = saveAsCustomReportModalInstance;
                    $scope.detailCustomReportModalInstance;
                }

				$scope.deleteCustomReport = function(report_id) {
					var deleteCustomReportModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/measure/customReport/detailCustomReport/deleteCustomReport/deleteCustomReport.html?app_v=deployDate',
                        controller: 'deleteCustomReportCtrl',
                    });

                    $scope.customReportName;
                    $scope.reportId = report_id;
                    $scope.deleteCustomReportModalInstance = deleteCustomReportModalInstance;
                    $scope.detailCustomReportModalInstance;
                    $scope.selectedAdvertiser;
				}

				$scope.closeModal = function() {
            		$modalInstance.close();
            	}


                $scope.sectionUp = function(index) {
                    if (index <= 0 || index >= $scope.selectedSection.length)
                        return;
                    var temp = $scope.selectedSection[index];
                    $scope.selectedSection[index] = $scope.selectedSection[index - 1];
                    $scope.selectedSection[index - 1] = temp;
                    $scope.selectedSection[index].position = $scope.selectedSection[index].position + 1;
                    $scope.selectedSection[index - 1].position = $scope.selectedSection[index].position - 1;
                    
                };

                $scope.sectionDown = function(index) {
                    if (index < 0 || index >= ($scope.selectedSection.length - 1))
                        return;
                    var temp = $scope.selectedSection[index];
                    $scope.selectedSection[index] = $scope.selectedSection[index + 1];
                    $scope.selectedSection[index + 1] = temp;
                    $scope.selectedSection[index].position = $scope.selectedSection[index].position - 1;
                    $scope.selectedSection[index + 1].position = $scope.selectedSection[index].position + 1;
                };


            	$scope.getDetailCustomReport();
			}
		])
})();